<template>
  <div>
    <PublicProfileHeader :content-type="content_type" :active-tab="1" />
    <v-container class="wrapper--my-pictures">
      <v-row class="row-profile-selector">
        <v-col
          class="text-center public-picture-toolbar"
          cols="12"
        >
          <div class="tw-toggle">
            <input
              id="rdo-personal"
              type="radio"
              name="toggle"
              value="false"
              :checked="content_type === 0"
              @click="checkContentType(0)"
            />
            <label
              for="rdo-personal"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccount}"
                class="mx-auto"
              >
                {{ mdiAccount }}
              </v-icon>
            </label>
            <input
              id="rdo-both"
              type="radio"
              name="toggle"
              value="-1"
              :checked="content_type === -1"
              @click="checkContentType(-1)"
            />
            <label
              for="rdo-both"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountMultiple}"
                class="mx-auto"
              >
                {{ mdiAccountMultiple }}
              </v-icon>
            </label>
            <input
              id="rdo-professional"
              type="radio"
              name="toggle"
              value="true"
              :checked="content_type === 1"
              @click="checkContentType(1)"
            />
            <label
              for="rdo-professional"
              class="toggle toggle-yes"
            >
              <v-icon
                :class="{'alternate-icon-small': !mdiAccountTie}"
                class="mx-auto"
              >
                {{ mdiAccountTie }}
              </v-icon>
            </label>
            <span></span>
          </div>
      <div class="public-picture-controls">
        <v-btn icon :color="randomView ? 'primary' : undefined" :aria-pressed="String(randomView)" aria-label="Random view" title="Random view" @click="toggleRandom">
          <v-icon>{{ mdiAllInclusive }}</v-icon>
        </v-btn>
        <v-btn icon :color="slider_view ? 'primary' : undefined" :aria-pressed="String(slider_view)" aria-label="Slideshow view" title="Slideshow view" @click="slider_view = !slider_view">
          <v-icon>{{ mdiViewCarousel }}</v-icon>
        </v-btn>
      </div>
        </v-col>
      </v-row>
      <v-row>
        <div class="d-flex justify-center wrapper-menu">
          <!-- ### Menu Mobile ### -->
          <template v-if="$vuetify.breakpoint.mdAndDown">
            <div
              v-if="active"
              class="inner-wrapper-menu"
            >
              <v-list class="mobile--menu-list">
                <v-list-group
                  :value="false"
                >
                  <template v-slot:activator>
                    <v-list-item-title>Categories</v-list-item-title>
                  </template>

                  <template v-if="!content_type || content_type === -1">
                    <div
                      v-for="(item, i) in categories"
                      :key="`system-${i}`"
                    >
                      <v-list-item
                        v-if="!item.children"
                        class="single_item"
                        link
                        @click="searchCategory(item.id, 1)"
                      >
                        <span>-</span> {{ item.name }}
                      </v-list-item>
                      <div v-else>
                        <v-list-group
                          :value="false"
                          no-action
                          sub-group
                        >
                          <template v-slot:activator>
                            <v-list-item-title @click="searchCategory(item.id, 1)">
                              {{ item.name }}
                            </v-list-item-title>
                          </template>
                          <div
                            v-for="(itemL1) in item.children"
                            :key="`system-L-${itemL1.id}`"
                          >
                            <v-list-item
                              v-if="!itemL1.children"
                              class="single_item"
                              link
                              @click="searchCategory(itemL1.id, 1)"
                            >
                              <span>-</span> {{ itemL1.name }}
                            </v-list-item>
                            <v-list-group
                              v-else
                              :value="false"
                              no-action
                              sub-group
                            >
                              <template v-slot:activator>
                                <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                  {{ itemL1.name }}
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                v-for="(itemL2, index) in itemL1.children"
                                :key="`system-L2-${index}`"
                                class="single_item"
                                link
                                @click="searchCategory(itemL2.id, 1)"
                              >
                                <span>-</span> {{ itemL2.name }}
                              </v-list-item>
                              <v-divider></v-divider>
                            </v-list-group>
                          </div>
                          <v-divider></v-divider>
                        </v-list-group>
                      </div>
                    </div>
                  </template>

                  <template v-if="content_type || content_type === -1">
                    <div
                      v-for="(item, i) in professionalCategories"
                      :key="`prof-${i}`"
                    >
                      <v-list-item
                        v-if="!item.children"
                        class="single_item"
                        link
                        @click="searchCategory(item.id, 1)"
                      >
                        <span>-</span> {{ item.name }}
                      </v-list-item>
                      <div v-else>
                        <v-list-group
                          :value="false"
                          no-action
                          sub-group
                        >
                          <template v-slot:activator>
                            <v-list-item-title @click="searchCategory(item.id, 1)">
                              {{ item.name }}
                            </v-list-item-title>
                          </template>
                          <div
                            v-for="(itemL1) in item.children"
                            :key="`prof-L-${itemL1.id}`"
                          >
                            <v-list-item
                              v-if="!itemL1.children"
                              class="single_item"
                              link
                              @click="searchCategory(itemL1.id, 1)"
                            >
                              <span>-</span> {{ itemL1.name }}
                            </v-list-item>
                            <v-list-group
                              v-else
                              :value="false"
                              no-action
                              sub-group
                            >
                              <template v-slot:activator>
                                <v-list-item-title @click="searchCategory(itemL1.id, 1)">
                                  {{ itemL1.name }}
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                v-for="(itemL2, index) in itemL1.children"
                                :key="`prof-L2-${index}`"
                                class="single_item"
                                link
                                @click="searchCategory(itemL2.id, 1)"
                              >
                                <span>-</span> {{ itemL2.name }}
                              </v-list-item>
                              <v-divider></v-divider>
                            </v-list-group>
                          </div>
                          <v-divider></v-divider>
                        </v-list-group>
                      </div>
                    </div>
                  </template>
                  <v-divider></v-divider>
                  <v-list-item
                    class="single_item"
                    :class="{ 'active': categorySelected === '' }"
                    @click="searchCategory(-1, 1)"
                  >
                    - All
                  </v-list-item>
                </v-list-group>
              </v-list>
            </div>
          </template>
          <div v-if="!$vuetify.breakpoint.mdAndDown">
            <ul
              v-if="!content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in categories"
                :key="`system-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`system-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`system-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
            </ul>

            <ul
              v-if="content_type || content_type === -1"
              class="list-menu clearfix"
            >
              <li
                v-for="(item) in professionalCategories"
                :key="`prof-${item.id}`"
              >
                <v-btn
                  :class="rootCategoryClasses(item.id)"
                  @click="searchCategory(item.id, 1)"
                >
                  {{ item.name }}
                  <v-icon
                    v-if="item.children"
                    :class="{'alternate-icon-small': !mdiChevronDown}"
                    class="mx-auto"
                  >
                    {{ mdiChevronDown }}
                  </v-icon>
                </v-btn>
                <ul v-if="item.children">
                  <li
                    v-for="(itemL1) in item.children"
                    :key="`prof-L-${itemL1.id}`"
                  >
                    <span @click="searchCategory(itemL1.id, 1)">
                      {{ itemL1.name }}
                      <v-icon
                        v-if="itemL1.children"
                        :class="{'alternate-icon-small': mdiChevronDown}"
                        class="mx-auto arrow-icon"
                      >
                        {{ mdiChevronDown }}
                      </v-icon>
                    </span>
                    <ul v-if="itemL1.children">
                      <li
                        v-for="(itemL2, index) in itemL1.children"
                        :key="`prof-L2-${index}`"
                      >
                        <span @click="searchCategory(itemL2.id, 1)">{{ itemL2.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <v-btn
                  :class="{ 'active': categorySelected === '' }"
                  elevation="2"
                  @click="searchCategory(-1, 1)"
                >
                  All
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
      </v-row>



      <v-row
        justify="center"
        class="mb-6"
      >
        <stack
          v-if="active"
          ref="stack"
          :column-min-width="300"
          :gutter-width="15"
          :gutter-height="15"
          monitor-images-loaded
        >
          <v-container
            v-if="!files.length"
            style="height: 400px;"
          >
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                v-if="!loading"
                class="text-subtitle-1 text-center"
                cols="12"
              >
                There are no content to show.
              </v-col>
              <v-progress-circular
                v-if="loading"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-row>
          </v-container>

          <template v-if="slider_view">
            <stack-item
              v-for="(file, i) in files"
              :key="`files-${i}`"
              style="transition: transform 300ms"
              @click.native="showModal(file)"
            >
              <v-card>
                <div
                  class="caption-style"
                  :class="{ 'caption-style--video': file.related_files.some(isVideo) }"
                >
                  <div v-if="file.view_type && file.related_files.length > 1">
                    <img
                      v-if="isImage(file.related_files[0])"
                      :src="`${file.related_files[0]}`"
                      :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[0] : 0}`"
                      @error="onImgError(file.related_files[0])"
                    />
                    <ListVideo
                      @click.stop
                      playsinline
                      preload="metadata"
                      :poster="videoPosterUrl(file.related_files[0], file)"
                      v-else-if="isVideo(file.related_files[0])"
                      width="100%"
                      height="100%"
                      controls
                      @loadedmetadata="reflow()"
                    >
                      <source
                        :src="videoPreviewUrl(file.related_files[0])"
                        :type="getVideoType(file.related_files[0])"
                      >
                      Your browser does not support the video tag.
                    </ListVideo>
                  </div>
                  <div v-else>
                    <v-carousel
                      v-if="file.related_files.length > 1"
                      height="100%"
                      @change="reflow()"
                    >
                      <v-carousel-item
                        v-for="(item, ic) in file.related_files"
                        :key="ic"
                      >
                        <img
                          v-if="isImage(item)"
                          :src="`${item}`"
                          :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[ic] : 0}`"
                          @error="onImgError(item)"
                        />
                        <ListVideo
                          @click.stop
                          playsinline
                          preload="metadata"
                          :poster="videoPosterUrl(item, file)"
                          v-else-if="isVideo(item)"
                          width="100%"
                          height="100%"
                          controls
                          @loadedmetadata="reflow()"
                        >
                          <source
                            :src="videoPreviewUrl(item)"
                            :type="getVideoType(item)"
                          >
                          Your browser does not support the video tag.
                        </ListVideo>
                      </v-carousel-item>
                    </v-carousel>
                    <div v-else>
                      <img
                        v-if="isImage(file.related_files[0])"
                        :src="`${file.related_files[0]}`"
                        :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[0] : 0}`"
                        @error="onImgError(file.related_files[0])"
                      />
                      <ListVideo
                        @click.stop
                        playsinline
                        preload="metadata"
                        :poster="videoPosterUrl(file.related_files[0], file)"
                        v-else-if="isVideo(file.related_files[0])"
                        width="100%"
                        height="100%"
                        controls
                        @loadedmetadata="reflow()"
                      >
                        <source
                          :src="videoPreviewUrl(file.related_files[0])"
                          :type="getVideoType(file.related_files[0])"
                        >
                        Your browser does not support the video tag.
                      </ListVideo>
                    </div>
                  </div>
                  <div
                    class="caption"
                    :data-categories="file.categories"
                  >
                    <div class="blur"></div>
                    <div class="caption-text">
                      <h1>{{ file.name }}</h1>
                      <p v-html="subString(file.alternative_text)"></p>
                    </div>
                  </div>
                </div>
              </v-card>
            </stack-item>
          </template>
          <template v-if="!slider_view">
            <template v-for="file in files">
              <stack-item
                v-for="(item, i_rlt) in file.related_files"
                :key="`file_${i_rlt+Math.random()}`"
                style="transition: transform 300ms"
                @click.native="showModal(file)"
              >
                <v-card>
                  <div
                    class="caption-style"
                    :class="{ 'caption-style--video': isVideo(item) }"
                  >
                    <img
                      v-if="isImage(item)"
                      :src="`${item}`"
                      :class="`rotate_images__position_${file.rotate_position ? file.rotate_position[0] : 0}`"
                      @error="onImgError(item)"
                    />
                    <ListVideo
                      @click.stop
                      playsinline
                      preload="metadata"
                      :poster="videoPosterUrl(item, file)"
                      v-else-if="isVideo(item)"
                      width="100%"
                      height="100%"
                      controls
                      @loadedmetadata="reflow()"
                    >
                      <source
                        :src="videoPreviewUrl(item)"
                        :type="getVideoType(item)"
                      >
                      Your browser does not support the video tag.
                    </ListVideo>
                    <div
                      class="caption"
                      :data-categories="file.categories"
                    >
                      <div class="blur"></div>
                      <div class="caption-text">
                        <h1>{{ file.name }}</h1>
                        <p v-html="subString(file.alternative_text)"></p>
                      </div>
                    </div>
                  </div>
                </v-card>
              </stack-item>
            </template>
          </template>
        </stack>
      </v-row>
      <v-pagination
        v-if="files.length"
        v-model="pagination"
        :length="qtdPages"
      ></v-pagination>
    </v-container>

    <PublicRecordDialog
      v-model="modalOpen"
      :record="selectedFile"
      :liked="!!(selectedFile && likeStatus[selectedFile.id])"
      :like-count="Number(selectedFile && likeCounts[selectedFile.id]) || 0"
      :owner-name="profileName"
      :owner-avatar="profileAvatar ? `https://self-biography-system.s3.us-east-2.amazonaws.com/${profileAvatar}` : ''"
      @like="toggleLike"
    />

    <LikersDialog
      v-model="likersDialogOpen"
      :file-id="likersDialogFileId"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { Stack, StackItem } from 'vue-stack-grid'
import {
  mdiChevronDown, mdiAccountTie, mdiAccount, mdiAccountMultiple, mdiAllInclusive, mdiViewCarousel,
  mdiHeartOutline, mdiHeart, mdiCommentOutline,
} from '@mdi/js'
import videoPreviewUrl, { videoPosterUrl } from '@/utils/videoPreview'
import ListVideo from '@/components/ListVideo.vue'
import PublicProfileHeader from '@/components/PublicProfileHeader.vue'
import LikersDialog from '@/components/LikersDialog.vue'
import PublicRecordDialog from '@/components/PublicRecordDialog.vue'

import { enabled } from '../../../utils/recordPrivacy'

export default {
  name: 'PublicPictures',
  components: {
    ListVideo,
    Stack,
    StackItem,
    PublicProfileHeader,
    LikersDialog,
    PublicRecordDialog,
  },
  data: () => ({
    slider_view: false,
    randomView: true,
    randomRanks: {},

    /* Icons */
    mdiChevronDown,
    mdiAccountTie,
    mdiAccount,
    mdiAccountMultiple,
    mdiAllInclusive,
    mdiViewCarousel,
    mdiHeartOutline,
    mdiHeart,
    mdiCommentOutline,

    /* ---- */
    active: 1,
    pagination: 1,
    qtdPages: 1,
    limitItems: 30,
    endpoint: process.env.VUE_APP_ROOT_API,
    categories: [],
    professionalCategories: [],
    files: [],
    allFiles: [],
    categorySelected: '',
    loading: true,
    content_type: 0,
    counterFlow: 0,
    failedImages: {},
    modalOpen: false,
    selectedFile: null,
    profileName: '',
    profileAvatar: '',
    likeStatus: {},
    likeCounts: {},
    likersDialogOpen: false,
    likersDialogFileId: null,
    modalCommentCount: 0,
  }),
  computed: {
    username() {
      return this.$route.params.username
    },
  },
  watch: {
    pagination(newPage) {
      if (newPage) {
        this.applyFilters()
      }
    },
  },
  mounted() {
    this.initializeFiltersFromRoute()
    this.loadData()
  },
  methods: {
    videoPreviewUrl,
    videoPosterUrl,
    toggleRandom() {
      this.randomView = !this.randomView
      this.pagination = 1
      this.applyFilters()
    },
    initializeFiltersFromRoute() {
      const queryContentType = Number.parseInt(this.$route.query.ct, 10)
      if (Number.isInteger(queryContentType)) {
        this.content_type = queryContentType
      } else {
        const storedType = Number.parseInt(localStorage.getItem('sb-shared-content-type'), 10)
        this.content_type = Number.isInteger(storedType) && [0, 1, -1].includes(storedType) ? storedType : 0
      }
      this.categorySelected = this.$route.query.cat || ''
      localStorage.setItem('sb-shared-content-type', String(this.content_type))
    },
    syncFiltersToRoute() {
      const nextQuery = { ...this.$route.query }
      localStorage.setItem('sb-shared-content-type', String(this.content_type))

      if (this.content_type === 0) {
        delete nextQuery.ct
      } else {
        nextQuery.ct = String(this.content_type)
      }

      if (this.categorySelected) {
        nextQuery.cat = String(this.categorySelected)
      } else {
        delete nextQuery.cat
      }

      const sameContentType = String(this.$route.query.ct || '') === String(nextQuery.ct || '')
      const sameCategory = String(this.$route.query.cat || '') === String(nextQuery.cat || '')
      if (!sameContentType || !sameCategory) {
        this.$router.replace({ query: nextQuery })
      }
    },
    findRootCategoryId(categories, targetId) {
      for (const category of categories) {
        if (Number(category.id) === Number(targetId)) return Number(category.id)
        if (category.children && category.children.length) {
          const nestedMatch = this.findRootCategoryId(category.children, targetId)
          if (nestedMatch !== null) return Number(category.id)
        }
      }

      return null
    },
    getSelectedRootCategoryId() {
      if (!this.categorySelected) return null
      const selectedId = Number(this.categorySelected)
      const personalMatch = this.findRootCategoryId(this.categories, selectedId)
      if (personalMatch !== null) return personalMatch

      return this.findRootCategoryId(this.professionalCategories, selectedId)
    },
    rootCategoryClasses(categoryId) {
      return {
        'root-category-active': Number(categoryId) === this.getSelectedRootCategoryId(),
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      try {
        const pathname = new URL(filePath).pathname
        const ext = pathname.split('.').pop().toLowerCase()
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
        const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
        if (imageExtensions.includes(ext)) return true
        if (videoExtensions.includes(ext)) return false
      } catch {
        // fallback
      }

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      try {
        const pathname = new URL(filePath).pathname
        const ext = pathname.split('.').pop().toLowerCase()
        const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
        if (videoExtensions.includes(ext)) return true
      } catch {
        // fallback
      }

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    getVideoType(filePath) {
      let ext = 'mp4'
      try {
        const pathname = new URL(filePath).pathname
        ext = pathname.split('.').pop().toLowerCase()
      } catch {
        ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      }
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    reflow() {
      if (this.counterFlow > this.files.length) {
        setTimeout(() => {
          this.$refs.stack.reflow()
        }, 500)
      }
      this.counterFlow++
    },
    checkContentType(val) {
      this.content_type = val
      this.searchCategory(-1, 1)
    },
    async loadData() {
      this.loading = true
      await this.getProfileInfo()
      await this.getCategories()
      await this.getFiles()
    },
    async getProfileInfo() {
      try {
        const response = await axios.get(`${this.endpoint}/getPublicUser?username=${encodeURIComponent(this.username)}`)
        const profile = response.data.content && response.data.content[0]
        this.profileName = profile ? profile.name || '' : ''
        this.profileAvatar = profile ? profile.avatar || '' : ''
      } catch {
        this.profileName = ''
        this.profileAvatar = ''
      }
    },
    searchCategory(value, page) {
      this.categorySelected = value !== -1 ? value : ''
      this.pagination = page
      this.loading = true
      this.syncFiltersToRoute()
      this.applyFilters()
    },
    async getCategories() {
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicCategories?username=${encodeURIComponent(this.username)}`,
        )
        this.categories = []
        this.professionalCategories = []
        if (response.data.content) {
          response.data.content.forEach(value => {
            if (value.type) {
              if (!value.content_type) {
                if (value.active) {
                  this.categories.push(value)
                }
              } else {
                if (value.active) {
                  this.professionalCategories.push(value)
                }
              }
            }
          })
        }
      } catch {
        // Categories loading failed silently
      }
    },
    async getFiles() {
      this.allFiles = []
      this.applyFilters()
      this.loading = true
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicItems?username=${encodeURIComponent(this.username)}`,
        )
        if (response.data.content) {
          this.allFiles = response.data.content.filter(item => enabled(item.public) && enabled(item.effective_public)).map(item => {
            if (item.rotate_position) {
              item.rotate_position = typeof item.rotate_position === 'string' ? item.rotate_position.split(', ') : item.rotate_position
            } else {
              item.rotate_position = []
            }
            if (!item.related_files) {
              item.related_files = []
            }

            return item
          })
          this.applyFilters()
          this.fetchLikeData(this.allFiles.map(f => f.id))
        }
      } catch {
        // Content loading failed silently
      }
      this.loading = false
    },
    applyFilters() {
      let filtered = this.allFiles.filter(item => enabled(item.public) && enabled(item.effective_public))

      // Filter by content_type
      if (this.content_type === 0) {
        filtered = filtered.filter(f => !f.content_type || f.content_type === 0)
      } else if (this.content_type === 1) {
        filtered = filtered.filter(f => f.content_type === 1)
      }

      // Filter by category
      if (this.categorySelected) {
        filtered = filtered.filter(f => {
          if (!f.categories) return false
          const cats = String(f.categories).split(', ').map(Number)

          return cats.includes(Number(this.categorySelected))
        })
      }

      // Keep a stable random order across pages and category changes.
      if (this.randomView) {
        filtered.forEach(item => {
          if (this.randomRanks[item.id] === undefined) this.randomRanks[item.id] = Math.random()
        })
        filtered.sort((a, b) => this.randomRanks[a.id] - this.randomRanks[b.id] || Number(a.id) - Number(b.id))
      } else {
        filtered.sort((a, b) => (Date.parse(a.updated_at) || 0) - (Date.parse(b.updated_at) || 0) || Number(a.id) - Number(b.id))
      }

      // Pagination
      this.qtdPages = Math.ceil(filtered.length / this.limitItems)
      const start = (this.pagination - 1) * this.limitItems
      const end = start + this.limitItems
      this.files = filtered.slice(start, end)
      this.loading = false
    },
    showModal(file) {
      this.selectedFile = file
      this.modalCommentCount = 0
      this.modalOpen = true
    },
    subString(value) {
      if (value !== undefined) {
        return `${value.substring(0, 140)}...`
      }

      return value
    },
    async fetchLikeData(fileIds) {
      if (!fileIds || !fileIds.length) return
      try {
        const token = this.$store.state.jwtToken
        if (token) {
          const response = await axios.get(
            `${this.endpoint}/getLikeStatus?file_ids=${fileIds.join(',')}`,
            { headers: { Authorization: token } },
          )
          if (response.data) {
            this.likeStatus = { ...this.likeStatus, ...response.data.likeStatus }
            this.likeCounts = { ...this.likeCounts, ...response.data.likeCounts }
          }
        } else {
          for (const id of fileIds) {
            try {
              const response = await axios.get(`${this.endpoint}/getLikes?file_id=${id}`)
              if (response.data) {
                this.$set(this.likeCounts, id, response.data.likeCount || 0)
              }
            } catch {
              // skip
            }
          }
        }
      } catch {
        // Silently fail
      }
    },
    async toggleLike(file) {
      if (!this.$store.state.jwtToken) return
      try {
        const response = await axios.post(`${this.endpoint}/toggleLike`, {
          file_id: file.id,
        }, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        if (response.data) {
          this.$set(this.likeStatus, file.id, response.data.liked)
          this.$set(this.likeCounts, file.id, response.data.likeCount)
        }
      } catch {
        // Silently fail
      }
    },
    openLikersDialog(fileId) {
      this.likersDialogFileId = fileId
      this.likersDialogOpen = true
    },
  },
}
</script>

<style lang="scss">
.vsg-stack-item {
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.2);

  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  video {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
  }
}

.caption-style {
  position: relative;
  padding: 0px;
  width: 100%;
  height: 100%;
  display: table;
}

.caption-style .icon {
  opacity: 0;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 5;
}

.caption-style:hover .caption,
.caption-style:hover .icon {
  opacity: 1;
}

.caption-style:hover img {
  opacity: 1;
  transform: scale(1.15, 1.15);

  &.rotate_images {
    &__position_0 {
      transform: rotate(0) scale(1) scale(1.15, 1.15);
    }

    &__position_1 {
      transform: rotate(90deg) scale(0.75) scale(1.15, 1.15);
    }

    &__position_2 {
      transform: rotate(180deg) scale(1) scale(1.15, 1.15);
    }

    &__position_3 {
      transform: rotate(270deg) scale(0.75) scale(1.15, 1.15);
    }
  }
}

.caption-style img {
  margin: 0px;
  padding: 0px;
  float: left;
  z-index: 0;
}

.caption-style video {
  margin: 0px;
  padding: 0px;
  display: block;
  z-index: 0;
}

.caption-style .caption{
  cursor: pointer;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  -webkit-transition:all 0.45s ease-in-out;
  -moz-transition:all 0.45s ease-in-out;
  -o-transition:all 0.45s ease-in-out;
  -ms-transition:all 0.45s ease-in-out;
  transition:all 0.45s ease-in-out;
  top: 0;
  z-index: 0;
}

.caption-style img{
  -webkit-transition:all 0.25s ease-in-out;
  -moz-transition:all 0.25s ease-in-out;
  -o-transition:all 0.25s ease-in-out;
  -ms-transition:all 0.25s ease-in-out;
  transition:all 0.25s ease-in-out;
}

.caption-style .blur{
  background-color: rgba(0,0,0,0.65);
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  max-height: 1000px;
}

.caption-style .caption-text h1{
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
  line-height: 25px;
  color: #fff !important;
  margin-bottom: 20px;
}
.caption-style .caption-text{
  z-index: 10;
  color: #fff;
  width: 80%;
  height: 100%;
  text-align: center;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
}
</style>

<style scoped lang="scss">
.wrapper-menu {
  flex: 1;
  position: relative;
  .v-btn {
    margin-bottom: 20px;
  }

  .v-btn:not(:last-child) {
    margin-right: 10px;
  }
}

.list-menu {
  margin: 0 0px !important;
  padding: 0 !important;
  justify-content: center !important;
  display: flex !important;
  li {
    text-align: left;
    list-style: none;
    cursor: pointer;
    position: relative;
    margin: 10px 0;
    ul {
      display: none;
      position: absolute;
      left: 0;
      width: auto;
      max-width: 300px;
      background: #fff;
      box-shadow: 0 4px 8px -4px rgb(94 86 105 / 42%);
      padding: 0;
      border-radius: 6px;
      top: 70%;
      z-index: 5;

      color:rgba(94, 86, 105, 0.87);
      text-transform: uppercase;
      font-size: 0.875rem;
      font-family: Inter, sans-serif;
      font-weight: 500;

      li {
        padding: 0 20px 0 15px;
        display: block;
        min-width: 150px;
        span {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .arrow-icon {
        transform: rotate(-90deg);
        position: absolute;
        right: -2px;
      }

      ul {
        left: 100%;
        top: -10px;
      }
    }
    &:hover {
      text-decoration: underline;
      > ul {
        display: block;
      }
    }
  }
  > li {
    float: left;
    margin: 0;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.like-action {
  display: inline-flex;
  align-items: center;

  .like-count {
    font-size: 13px;
    margin-left: 4px;
    font-weight: 500;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.root-category-active {
  background-color: #9155fd !important;
  border-color: #9155fd !important;
  color: #fff !important;
}
</style>

<style scoped>
.public-picture-toolbar { display: grid; grid-template-columns: minmax(80px, 1fr) auto minmax(80px, 1fr); align-items: center; }
.public-picture-toolbar > .tw-toggle { grid-column: 2; }
.public-picture-controls { grid-column: 3; display: flex; justify-content: flex-end; gap: 8px; }
@media (max-width: 400px) {
  .public-picture-toolbar { grid-template-columns: auto 1fr; }
  .public-picture-toolbar > .tw-toggle { grid-column: 1; }
  .public-picture-controls { grid-column: 2; }
}
</style>
